import { useEffect } from "react";
import useFetch from "hooks/useFetch";
import mixpanel from "mixpanel-browser";
import { useSetRecoilState } from "recoil";
import { setAuthHeaders } from "api";
import { userAtom } from "recoil/userAtom";
import { useNavigate } from "react-router-dom";

export default function useLoginCoach({
  url,
  requestBody,
  onNotCoach,
}: {
  url: string;
  requestBody: string;
  onNotCoach?: () => void;
}) {
  let navigate = useNavigate();

  const [loginResult, login] = useFetch({
    url: url,
    requestBody: requestBody,
  });

  const setUser = useSetRecoilState(userAtom);

  useEffect(() => {
    if (loginResult) {
      const result = loginResult.result;

      if (!result) return;
      if (!result.accessToken) return;
      if (
        result.email === undefined ||
        !result.email.includes("@orwellhealth.org")
      ) {
        if (onNotCoach) onNotCoach();
        return;
      }

      mixpanel.identify(result.trackId);

      setAuthHeaders(result.accessToken);

      setUser(result);

      navigate("/", { replace: true });
    }
  }, [loginResult]);

  return login;
}
